import type { IconNode } from '../types';

/**
 * @name mail-dot
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuNjc0IDRINGEyIDIgMCAwIDAtMiAydjEyYTIgMiAwIDAgMCAyIDJoMTZhMiAyIDAgMCAwIDItMnYtNC42NzUiIC8+CiAgPHBhdGggZD0ibTIgNyA5IDUuNzAxYTIgMiAwIDAgMCAyIDBsMS4wODQtLjY4NiIgLz4KICA8Y2lyY2xlIGN4PSIxOSIgY3k9IjciIHI9IjMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/mail-dot
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const MailDot: IconNode = [
  ['path', { d: 'M12.674 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4.675' }],
  ['path', { d: 'm2 7 9 5.701a2 2 0 0 0 2 0l1.084-.686' }],
  ['circle', { cx: '19', cy: '7', r: '3' }],
];

export default MailDot;
